import { classNames } from '@utils/class-names';
import React from 'react';
export const Panel = ({ children, dataTestId, rounded = 'none', className, padding = 'p-4', greyOnDesktop = false, }) => {
    return (React.createElement("div", { className: classNames('bg-white', greyOnDesktop && 'desktop:bg-bgGray', rounded === 'all' && 'rounded-sm', rounded === 'top' && 'rounded-t-sm', rounded === 'bottom' && 'rounded-b-sm', padding, className), "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'Panel' }, children));
};
